import React, { useState, useEffect } from "react";
import Seo from "../../../utils/seo/Seo";
import "./PlaneFeature.css";
import tick from "../../../assets/icons/tick.svg";
import usFlag from "../../../assets/us-flag.webp";
import framePhoto from "../../../assets/frame-photo.webp";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useUserContext } from "../../../context/MemorialContext";
import { US_STATES, EXCLUDED_SHIPPING_STATES } from "../../../utils/usStates";

function PlaneFeature() {
  const [message, setMessage] = useState();
  const { user } = useUserContext();
  const [frameLoading, setFrameLoading] = useState(false);
  const [showFrameModal, setShowFrameModal] = useState(false);
  const [frameShippingState, setFrameShippingState] = useState("");
  const [frameShippingCountry, setFrameShippingCountry] = useState("US");
  const [frameError, setFrameError] = useState("");

  const canBuyFrame =
    frameShippingCountry === "US" &&
    frameShippingState &&
    !EXCLUDED_SHIPPING_STATES.includes(frameShippingState);

  const Plans = [{
    price:"$0.00",
    features:["Never Expire","5 Photos"]
},{
    price:"$49.99",
    features:["Never Expire","Unlimited Photos","Video and Music Gallery","Social Media Integration","Custom Background Music","Advanced Privacy Controls","Additional Administrators","Custom Notifications"]
}
,{
    price:"$69.99",
    features:["Never Expire","Unlimited Photos","Video and Music Gallery","Social Media Integration","Custom Background Music","Advanced Privacy Controls","Additional Administrators","Custom Notifications","custom picture frame"]
}]
  const navigate = useNavigate();
  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- continue to shop around and checkout when you're ready.",
      );
    }
  }, []);

  // Scroll to Additional frames section when URL has #additional-frames (e.g. from menu "Buy frame")
  useEffect(() => {
    if (window.location.hash === "#additional-frames") {
      const el = document.getElementById("additional-frames");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, []);

  const handleSubmit = async (event) => {
    navigate("/creatememorial");
  };

  return (
    <>
      <Seo
        title="Memorial Website Pricing & Plans"
        description="Compare free, standard, and premium memorial website plans. Unlimited photos, video gallery, music, privacy controls, and optional picture frame."
        path="/pricing"
      />
    <div className="pf-page">
      <div className="pf-top">
        <h2>PLANS AND FEATURES</h2>
      </div>
      <div className="pf-pricing">
        <div className="pricing-text">
          <p>One Price, Endless Memories</p>
          <p>For Your</p>
          <p className="pfont">loved ones</p>
          {/* <img src={arrow} alt="Arrow" /> */}
        </div>
<div className="grid-cards">
       {Plans.map((item, planIndex) => <div className="pricing-card" key={planIndex}>
          {planIndex === 0 && <p className="life">Free Plan</p>}
          {planIndex === 1 && <p className="life">Standard Plan</p>}
          {planIndex === 2 && <p className="life">Premium Plan</p>}
          <h2>{item.price}</h2>
          <p className="flexible">Most flexible</p>

          <p className="divider"></p>

        { item.features.map((feat) => <p className="line" key={feat}>
            <img src={tick} alt="Tick" /> <span>{feat}</span>
          </p>) }
          {item.price === "$69.99" && (
            <p className="line shipping-disclaimer" style={{ fontSize: "12px", color: "rgba(255,255,255,0.9)", marginTop: "8px", fontStyle: "italic" }}>
              Made in the USA <img src={usFlag} alt="USA" style={{ height: "1em", width: "auto", verticalAlign: "middle", display: "inline-block" }} />
              <br />
              Shipping within USA only (excluding HI and AK).
            </p>
          )}
          <p>{message}</p>

          <button className="get-started" onClick={() => handleSubmit()}>
            Get Started
          </button>
        </div>) }
        </div>

        <div id="additional-frames" className="pricing-text pf-additional-frames">
          <p className="pfont pf-additional-frames-heading">Additional frames</p>
          <div className="pf-additional-frames-layout">
            <div className="pf-additional-frames-visual">
              <img
                src={framePhoto}
                alt="Custom WillAlwaysLoveU memorial picture frame with QR code"
                className="pf-frame-photo"
              />
            </div>
            <div className="pf-additional-frames-copy">
              <p className="pf-additional-frames-desc">
                Need another picture frame? Purchase one for <strong>$25</strong>. Made in the USA.
                Shipping within USA only (excluding HI and AK).
              </p>
              {user?.meta?._id ? (
                <button
                  className="get-started"
                  onClick={() => {
                    setFrameError("");
                    setFrameShippingState("");
                    setFrameShippingCountry("US");
                    setShowFrameModal(true);
                  }}
                >
                  Buy additional frame
                </button>
              ) : (
                <div className="pf-signin-cta">
                  <p>To purchase an additional frame, please sign in.</p>
                  <button
                    type="button"
                    className="get-started pf-signin-btn"
                    onClick={() => navigate("/login")}
                  >
                    Sign in
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="pfbottom"></div>

      {showFrameModal && (
        <div
          className="frame-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => !frameLoading && setShowFrameModal(false)}
        >
          <div
            className="frame-modal"
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "24px",
              maxWidth: "420px",
              width: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: "0 0 12px 0", color: "#5c5470", fontSize: "1.25rem" }}>
              Confirm shipping destination
            </h3>
            <p style={{ margin: "0 0 16px 0", color: "#555", fontSize: "14px" }}>
              Made in the USA <img src={usFlag} alt="USA" style={{ height: "1em", width: "auto", verticalAlign: "middle", display: "inline-block" }} />
              <br />
              Shipping within USA only (excluding HI and AK).
            </p>
            <label htmlFor="frame-shipping-country" style={{ display: "block", marginBottom: "4px", fontWeight: 600, fontSize: "14px" }}>
              Country
            </label>
            <select
              id="frame-shipping-country"
              value={frameShippingCountry}
              onChange={(e) => {
                setFrameShippingCountry(e.target.value);
                setFrameShippingState("");
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                marginBottom: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <option value="US">United States</option>
              <option value="other">Other (frame not available)</option>
            </select>
            {frameShippingCountry === "US" && (
              <>
                <label htmlFor="frame-shipping-state" style={{ display: "block", marginBottom: "4px", fontWeight: 600, fontSize: "14px" }}>
                  State
                </label>
                <select
                  id="frame-shipping-state"
                  value={frameShippingState}
                  onChange={(e) => setFrameShippingState(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    marginBottom: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                >
                  <option value="">Select state</option>
                  {US_STATES.map((s) => (
                    <option key={s.code} value={s.code}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </>
            )}
            {frameShippingCountry !== "US" || (frameShippingState && EXCLUDED_SHIPPING_STATES.includes(frameShippingState)) ? (
              <p style={{ margin: "0 0 12px 0", padding: "10px", background: "#f8d7da", color: "#721c24", borderRadius: "8px", fontSize: "13px" }}>
                Shipping within USA only (excluding HI and AK).
              </p>
            ) : null}
            {frameError && <p style={{ margin: "0 0 12px 0", color: "#c00", fontSize: "13px" }}>{frameError}</p>}
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "16px" }}>
              <button
                type="button"
                onClick={() => { setShowFrameModal(false); setFrameError(""); }}
                disabled={frameLoading}
                style={{ padding: "10px 20px", borderRadius: "8px", border: "1px solid #5c5470", background: "#fff", color: "#5c5470", cursor: frameLoading ? "not-allowed" : "pointer" }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={async () => {
                  if (!canBuyFrame || frameLoading || !user?.meta?._id) return;
                  setFrameError("");
                  setFrameLoading(true);
                  try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
                    const res = await axios.post(`${backendUrl.replace(/\/$/, "")}/api/create-upgrade-session`, {
                      userId: user.meta._id,
                      isFramePurchase: true,
                      shippingState: frameShippingState,
                    });
                    if (res.data?.url) {
                      window.location.href = res.data.url;
                    } else {
                      setFrameError(res.data?.error || "Could not start checkout.");
                    }
                  } catch (err) {
                    setFrameError(err.response?.data?.error || err.message || "Something went wrong.");
                  } finally {
                    setFrameLoading(false);
                  }
                }}
                disabled={!canBuyFrame || frameLoading}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: canBuyFrame && !frameLoading ? "#5c5470" : "#ccc",
                  color: "#fff",
                  cursor: canBuyFrame && !frameLoading ? "pointer" : "not-allowed",
                }}
              >
                {frameLoading ? "..." : "Continue to payment"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default PlaneFeature;
